module.exports = __webpack_public_path__ + "img/icon_train_default.036d408b.png";